import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './PlayButton.styles';

class PlayButton extends React.Component {
  state = {
    paused: true
  };
  componentDidUpdate(prev){
    if(this.props.reset !== prev.reset){
      this.setState({paused: this.props.reset});
    }
  }
  handleClick (evnt){
    let playing = this.state.paused;
    if(this.props.onClick){
      this.props.onClick(playing);
    }
    this.setState({paused: !playing})
  }
  render() {
    let icon = 'fas fa-pause'
    if(this.state.paused){
      icon = 'fas fa-play';
    }
    return (
      <span className={css(styles.base, this.props.styles)} onClick={this.handleClick.bind(this)}>
        <i className={icon}></i>
      </span>
    );
  }
};

export default PlayButton;


// WEBPACK FOOTER //
// ./src/components/data/historymap/PlayButton.js